import { Globe2 } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger, cn } from "@atrix-analytics/ui";
import type { Region, RegionCode } from "../api/schemas";

const FLAG_LABEL: Record<RegionCode, string> = { eu: "EU", me: "UAE", us: "US", pk: "PK" };

/** Always visible: where this project's data lives. Residency is the product's promise. */
export function RegionBadge({ code, region, className }: { code: RegionCode; region?: Region; className?: string }) {
  const name = region?.name ?? FLAG_LABEL[code];
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          tabIndex={0}
          className={cn(
            "inline-flex h-7 shrink-0 items-center gap-1.5 rounded-md border border-border-strong bg-bg-raised px-2 text-xs font-medium text-fg",
            className,
          )}
          aria-label={`Data region: ${name}`}
        >
          <Globe2 aria-hidden className="size-3.5 text-fg-muted" />
          <span className="font-mono tracking-wide">{FLAG_LABEL[code]}</span>
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-64">
        Data region: <strong>{name}</strong>. Events, people and query results for this project are stored and
        processed only in this region.
      </TooltipContent>
    </Tooltip>
  );
}
